import { render, staticRenderFns } from "./character.vue?vue&type=template&id=194dbf94"
import script from "./character.vue?vue&type=script&lang=ts"
export * from "./character.vue?vue&type=script&lang=ts"
import style0 from "./character.vue?vue&type=style&index=0&id=194dbf94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports